import { Asset } from 'src/modules/common/types/Asset';
import { createActions } from 'src/utils/createActions';
import { createTrigger } from 'src/utils/createTrigger';

export const ASSET_UPLOAD = createActions<File, Asset, string>('ASSET_UPLOAD');
export const ASSET_CANCEL = createTrigger<void, string>('ASSET_CANCEL');
